var ResponseEventDto = (function () {
    function ResponseEventDto(event) {
        this.eventName = event.eventName || '';
        this.eventData = event.eventData;
    }
    ResponseEventDto.fromOcapi = function (event) {
        return new ResponseEventDto(event);
    };
    ResponseEventDto.getMiniCartUpdateEvent = function (basket) {
        return this.fromOcapi({
            eventName: 'reactEvent',
            eventData: {
                eventName: 'count:update',
                target: '.minicart',
                eventData: {
                    quantityTotal: basket.productQuantity,
                    minicartCountOfItems: basket.miniCartLabel,
                },
            },
        });
    };
    ;
    ResponseEventDto.getCartUpdateEvent = function (data) {
        var event = {
            eventName: 'reactEvent',
            eventData: {
                eventName: 'cart:update',
                target: '.minicart',
            }
        };
        if (data) {
            event.eventData['eventData'] = data;
        }
        return event;
    };
    ;
    ResponseEventDto.getProductAddEvent = function (data) {
        var event = {
            eventName: 'reactEvent',
            eventData: {
                eventName: 'product:afterAddToCart',
                target: 'body'
            }
        };
        if (data) {
            event.eventData['eventData'] = data;
        }
        return event;
    };
    ;
    ResponseEventDto.getUpdateSkuEvent = function (eventName, target, data) {
        var event = {
            eventName: 'reactEvent',
            eventData: {
                eventName: eventName,
                target: target
            }
        };
        if (data) {
            event.eventData['eventData'] = data;
        }
        return event;
    };
    return ResponseEventDto;
}());
export { ResponseEventDto };
//# sourceMappingURL=ResponseEventDto.js.map